export function matchesSearch(
  option: { value: string; keywords?: string[] },
  search: string
): boolean {
  const lower = search.toLowerCase()
  if (option.value.toLowerCase().includes(lower)) return true
  return option.keywords?.some(k => k.toLowerCase().includes(lower)) ?? false
}
